// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","logo__imgage":"Logo_logo__imgage__19oVD"};